export default {
    tarif() {
        var url = "content/voucher-tarif/tarif";
        return url;
    },
    tarifUpdate() {
        var url = "content/voucher-tarif/update";
        return url;
    },
    tarifHapus() {
        var url = "content/voucher-tarif/hapus";
        return url;
    },
    tarifTambah() {
        var url = "content/voucher-tarif/tambah";
        return url;
    },

    // MIKROTIK LIST
    mikrotikList() {
        var url = "content/mikrotik/list";
        return url;
    },
    mikrotikProfil() {
        var url = "profile-list.php";
        return url;
    },
    mikrotikDetail() {
        var url = "content/mikrotik/detail";
        return url;
    },
    modemUpdate() {
        var url = "content/pelanggan/update-modem";
        return url;
    },

    // VOUCHER
    voucherList() {
        var url = "VoucherList";
        return url;
    },
    voucherTambahToMikrotik() {
        var url = "voucher-tambah.php";
        return url;
    },
    voucherTambah() {
        var url = "content/voucher/tambah";
        return url;
    },
    updateVoucherPrint() {
        var url = "content/voucher/update-print";
        return url;
    },
    
    // PEMBAYARAN BY ADMIN
    pembayaranByAdmin() {
        var url = "pembayaran-by-admin";
        return url;
    },
    getHistoryByAdmin() {
        var url = "history-get-admin";
        return url;
    },
    getHistoryByArea() {
        var url = "history-get-area";
        return url;
    },
    Rangkuman() {
        var url = "content/pembukuan/rangkuman";
        return url;
    },
    
    // ADMIN 
    AdminListKangTagih() {
        var url = "content/admin/kangtagih";
        return url;
    },
    AdminList() {
        var url = "content/admin/list";
        return url;
    },
    AdminUpdate() {
        var url = "content/admin/update-password";
        return url;
    },
    AdminMikrotikUpdate() {
        var url = "content/admin/update-mikrotik";
        return url;
    },
    AdminAreaUpdate() {
        var url = "content/admin/update-area"; //ListArea
        return url;
    },
    AdminHapus() {
        var url = "content/admin/hapus";
        return url;
    },
    AdminTambah() {
        var url = "content/admin/tambah";
        return url;
    },
    AdminTambahTeknisi() {
        var url = "content/admin/tambah-teknisi";
        return url;
    },
    AdminListKangTeknisi() {
        var url = "content/admin/list-teknisi";
        return url;
    },
    AdminDetailPelanggan() { 
        var url = "content/admin/detail-pelanggan";
        return url;
    },
    AdminDetailPelangganBelum() {
        var url = "content/admin/detail-pelanggan-belum";
        return url;
    },
    AdminDetailPelangganSudah() {
        var url = "content/admin/detail-pelanggan-sudah";
        return url;
    },
    AdminDetailPengeluaran() {
        var url = "content/admin/detail-pengeluaran";
        return url;
    },

    // PELANGGAN
    PelangganList() {
        var url = "content/pelanggan/list";
        return url;
    },
    PelangganListCari() {
        var url = "content/pelanggan/cari";
        return url;
    },
    PelangganTambah() {
        var url = "content/pelanggan/tambah";
        return url;
    },
    PelangganImport() {
        var url = "content/pelanggan/import";
        return url;
    },
    PelangganEdit() {
        var url = "content/pelanggan/edit"; // EditUser
        return url;
    },
    PelangganAlamatUpdate() {
        var url = "content/pelanggan/update-alamat"; // EditUser
        return url;
    },
    PelangganUpdateMikrotik() {
        var url = "content/pelanggan/update-mikrotik"; // EditUser
        return url;
    },
    PelangganMap() {
        var url = "content/pelanggan/map";
        return url;
    },
    PelangganHapus() {
        var url = "content/pelanggan/hapus";
        return url;
    },
    PelangganHapusMulti() {
        var url = "content/pelanggan/hapus-multi";
        return url;
    },
    PelangganResetPassMulti() {
        var url = "content/pelanggan/reset-password-multi";
        return url;
    },
    PelangganNunggakTelat() {
        var url = "content/pelanggan/nunggak-jumlah";
        return url;
    },
    TelatListList() {
        var url = "content/pelanggan/telat-list";
        return url;
    },
    
    // DASHBORAD
    Ppn() {
        var url = "content/beranda/ppn";
        return url;
    },

    // PROFIL
    UpdateProfil() {
        var url = "EditNamaKu";
        return url;
    },
    UpdatePassword() {
        var url = "EditPasswordKu";
        return url;
    },

    // PEMBUKUAN
    PembukuanDashboard() {
        var url = "content/pengeluaran/baca";
        return url;
    },
    PembukuanList() {
        var url = "content/pembukuan/list";
        return url;
    },
    Pengeluaran() {
        var url = "content/pengeluaran/list";
        return url;
    },
    PembukuanTambah() {
        var url = "content/pengeluaran/tambah";
        return url;
    },
    SisaUang() {
        var url = "content/pengeluaran/sisa";
        return url;
    },
    SisaRincian() {
        var url = "content/pengeluaran/sisa-rincian";
        return url;
    },
    HistoryPembayaran() {
        var url = "content/transaksi/history-pembayaran";
        return url;
    },
    
    // KANG VOUCHER
    kangVoucherList() {
        var url = "content/voucher/kang-voucher";
        return url;
    },
    kangVoucherHistory() {
        var url = "content/voucher/history-saldo";
        return url;
    },
    kangVoucherTambahSaldo() {
        var url = "content/voucher/tambah-saldo";
        return url;
    },
    kangVoucherSaldo() {
        var url = "content/voucher/saldo-by-admin";
        return url;
    },

    // MIKROTIK DETAIL
    MikrotikDetail() {
        var url = "content/mikrotik/detail";
        return url;
    },
    MikrotikDetailFromAdmin() {
        var url = "content/mikrotik/detail-from-admin";
        return url;
    },
    MiktorikList() {
        var url = "content/mikrotik/list";
        return url;
    },
    MiktorikSimpan() {
        var url = "content/mikrotik/simpan";
        return url;
    },
    MiktorikHapus() {
        var url = "content/mikrotik/hapus";
        return url;
    },

    // PENGELUARAN
    Pengeluaran() {
        var url = "content/pengeluaran/list";
        return url;
    },
    PengeluaranHapus() {
        var url = "content/pengeluaran/hapus";
        return url;
    },
    
    // PENGELUARAN
    ListPaket() {
        var url = "content/paket/list";
        return url;
    },
    EditPaket() {
        var url = "content/paket/edit";
        return url;
    },
    HapusPaket() {
        var url = "HapusTarif";
        return url;
    },
    
    // PENGELUARAN
    ListNetwork() {
        var url = "content/network/tree";
        return url;
    },
    ListNetworkCek() {
        var url = "content/network/cek";
        return url;
    },

    // WHATSAPP
    SaveSesi() {
        var url = "content/wa/save-sesi";
        return url;
    },
    GetSesi() {
        var url = "content/wa/get-sesi";
        return url;
    },
    ResetWA() {
        var url = "content/wa/reset";
        return url;
    },
    HistoryWA() {
        var url = "content/wa/history";
        return url;
    },
    // AREA
    ListArea() {
        var url = "content/area/list"; //ListArea
        return url;
    },
    ListAreaBy() {
        var url = "content/area/list-by"; //ListArea
        return url;
    },

    // LAPORAN
    Laporan() {
        var url = "content/laporan/list"; //ListArea
        return url;
    },


    // FORUM
    ForumList() {
        var url = "content/posting/list"; 
        return url;
    },
    ForumUpload() {
        var url = "content/posting/upload-image"; 
        return url;
    },
    ForumPost() {
        var url = "content/posting/create"; 
        return url;
    },
    ForumKomen() {
        var url = "content/posting/detail"; 
        return url;
    },
    ForumKomenPost() {
        var url = "content/posting/comment"; 
        return url;
    },
    BerandaPPOE() {
        var url = "content/pelanggan/beranda-ppoe"; 
        return url;
    },

    getDashboardPPOEUang() {
        var url = "content/pelanggan/beranda-ppoe-uang"; 
        return url;
    },

    // INFO
    InfoTeksSimpan() {
        var url = "SimpanWA"; 
        return url;
    },

    // PERUSAHAAN
    UpdatePerusahaan() {
        var url = "content/admin-perusahaan/update-perusahaan"; 
        return url;
    },
    getPerusahaan() {
        var url = "content/admin-perusahaan/perusahaan"; 
        return url;
    },
    getPerusahaanOTP() {
        var url = "content/admin-perusahaan/req-otp"; 
        return url;
    },
    getPerusahaanUploads() {
        var url = "content/admin-perusahaan/upload"; 
        return url;
    },
    MitraList() {
        var url = "content/mitra/list"; 
        return url;
    },
    MitraJumlah() {
        var url = "content/mitra/jumlah"; 
        return url;
    },
    MitraTambah() {
        var url = "content/mitra/tambah"; 
        return url;
    },
    MitraArea() {
        var url = "content/mitra/area"; 
        return url;
    },
    MitraAreaHapus() {
        var url = "content/mitra/area-hapus"; 
        return url;
    },
    MitraAreaSimpan() {
        var url = "content/mitra/area-simpan"; 
        return url;
    },
    MitraUpdate() {
        var url = "content/mitra/update"; 
        return url;
    },
    MitraUp() {
        var url = "content/mitra/upgrade"; 
        return url;
    },
    MitraBw() {
        var url = "content/mitra/bandwith"; 
        return url;
    },
    MitraBayar() {
        var url = "content/mitra/bayar"; 
        return url;
    },
    MitraBlankBayar() {
        var url = "content/mitra/bayar-blank"; 
        return url;
    },
    MitraHistoryBayar() {
        var url = "content/mitra/history-bayar"; 
        return url;
    },
    MitraHapus() {
        var url = "content/mitra/hapus"; 
        return url;
    },
    MitraCek() {
        var url = "content/mitra/cek"; 
        return url;
    },
    IsISP() {
        var url = "content/isp/cek"; 
        return url;
    },

    //
    ODPMultiCari() {
        var url = "content/odc/multi-cari"; 
        return url;
    },
    ODPList() {
        var url = "content/odc/list"; 
        return url;
    },
    ODPTeknisi() {
        var url = "content/admin/list-teknisi-tugas"; 
        return url;
    },
    ODPPelanggan() {
        var url = "content/odc/odp-pelanggan"; 
        return url;
    },
    ODCODPList() {
        var url = "content/odc/list"; 
        return url;
    },
    ODCODPTambah() {
        var url = "content/odc/tambah"; 
        return url;
    },
    ODCODPHapus() {
        var url = "content/odc/hapus"; 
        return url;
    },
    // TUGAS
    TugasList() {
        var url = "content/admin/tugas-list"; 
        return url;
    },
    TugasTotal() {
        var url = "content/admin/tugas-total"; 
        return url;
    },
    TugasDetail() {
        var url = "content/admin/tugas-detail"; 
        return url;
    },
    TeknisiList() {
        var url = "content/admin/list-teknisi-tugas"; 
        return url;
    },
    TugasUpdateTeknisi() {
        var url = "content/admin/tugas-update-teknisi"; 
        return url;
    },
    PelangganCariPopup() {
        var url = "content/pelanggan/cari-popup"; 
        return url;
    },
    TugasTambah() {
        var url = "content/admin/tugas-tambah"; 
        return url;
    },
    CancelIsolir() {
        var url = "content/pelanggan/isolir-cancel"; 
        return url;
    },
    postBalikin() {
        var url = "BalikinTransaksi"; 
        return url;
    },
    SliderUploads() {
        var url = "content/slider/upload"; // ini tempat upload slider ke hosting lain
        return url;
    },
    SliderSimpan() {
        var url = "content/slider/simpan"; // ini tempat simpan slider ke database
        return url;
    },
    TugasJumlah() {
        var url = "content/admin/tugas-jumlah"; 
        return url;
    },
    getInvoice() {
        var url = "content/invoice/total"; 
        return url;
    },
    TugasTeknisiList() {
        var url = "content/admin/tugas-list"; 
        return url;
    },


    // PELANGGAN ================================================
    getUserCariMultiFilter() {
        var url = "content/pelanggan/cari-multi";  
        return url;
    },
    getUserIsolir() {
        var url = "content/pelanggan/list"; 
        return url;
    },
    getUserNetwork() {
        var url = "content/network/network-detail"; 
        return url;
    },
    UserDetail() {
        var url = "content/pelanggan/detail"; 
        return url;
    },


    // PENGADUAN ================================================
    Pengaduan() {
        var url = "content/pengaduan/list"; 
        return url;
    },


    // INVOICE
    historyInvoice() {
        var url = "content/invoice/history";
        return url;
    },
    Saldo() {
        var url = "content/invoice/total";
        return url;
    },
    HistorySaldo() {
        var url = "content/invoice/history-inv";
        return url;
    },
    HistoryWithdraw() {
        var url = "content/invoice/history-wd";
        return url;
    },

    postPassword() {
        var url = "content/admin/pass-cek";
        return url;
    },

    tagihanCek() {
        var url = "content/pelanggan/tagihan-cek";
        return url;
    },

    postBayarNew() {
        var url = "content/pelanggan/bayar";
        return url;
    },

    adminSetor() {
        var url = "content/pengeluaran/admin-setor";
        return url;
    },

    // whatsapp
    WaPelangganList() {
        var url = "content/pelanggan/wa-list";
        return url;
    },

    ListPelangganSekitarJSON() {
        var url = "content/pelanggan/sekitar";
        return url;
    },

    AllPelangganForMikrotik() {
        var url = "content/pelanggan/get-all-for-mikrotik";
        return url;
    },

    // whatsapp
    QRToken() {
        var url = "content/device/qrtoken";
        return url;
    },

    
}


// WEBPACK FOOTER //
// ./src/globalFunc/Interface.js